module.exports = __webpack_public_path__ + "static/media/file.b04fe063.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/DownloadModal/file.png
// module id = 542
// module chunks = 0